// extracted by mini-css-extract-plugin
export default {"wrapper":"Features_wrapper__rq7mT","card":"Features_card__Qr1BF","title":"Features_title__sMrPE","grid":"Features_grid__QR8j4","checkboxLabel":"Features_checkboxLabel__HVH4c"};